var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C13.9707 0 18 4.0293 18 9C18 13.9707 13.9707 18 9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0ZM12.1815 5.7429L7.7265 10.1979L5.8185 8.289C5.73494 8.20538 5.63573 8.13904 5.52653 8.09376C5.41733 8.04848 5.30028 8.02516 5.18207 8.02512C4.94333 8.02503 4.71433 8.11979 4.54545 8.28855C4.37657 8.45731 4.28165 8.68624 4.28157 8.92498C4.28148 9.16372 4.37624 9.39272 4.545 9.5616L7.0272 12.0438C7.11914 12.1358 7.22829 12.2087 7.34844 12.2585C7.46858 12.3083 7.59735 12.3339 7.7274 12.3339C7.85745 12.3339 7.98622 12.3083 8.10636 12.2585C8.22651 12.2087 8.33566 12.1358 8.4276 12.0438L13.455 7.0164C13.6239 6.84752 13.7187 6.61848 13.7187 6.37965C13.7187 6.14082 13.6239 5.91178 13.455 5.7429C13.2861 5.57402 13.0571 5.47915 12.8182 5.47915C12.5794 5.47915 12.3504 5.57402 12.1815 5.7429Z",
    fill: "#01DC3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiks);
export default __webpack_public_path__ + "static/media/tiks.9b866008f507c6038a14d377f1969026.svg";
export { ForwardRef as ReactComponent };